// Päivitysnäkymät: ikkuna, joka ilmestyy kun palvelimella on uudempi versio (sovelluksen käynnistyessä), ja
// Passin "Päivitykset"-kortti, josta voi tarkistaa ja ladata päivityksen milloin vain.
// Tila ja logiikka: lib/useAppUpdate.js ja lib/appUpdate.js.

import { releaseLine, statusLine } from "../lib/appUpdate.js";
import { Sheet } from "./Sheet.jsx";

/** Ikkuna uudesta versiosta. Näkyy vain kun update.prompt on tosi. */
export function UpdateSheet({ update }) {
  if (!update.prompt || !update.remote) return null;
  return (
    <Sheet title="Päivitys saatavilla" onClose={update.dismiss}>
      <p>{releaseLine(update.remote)} on valmis. Lataus aukeaa selaimessa, ja Android pyytää lopuksi vahvistamaan asennuksen. Päivitys asentuu vanhan päälle, eikä tietoja katoa.</p>
      <div class="sheet-actions">
        <button class="btn btn-rasti btn-block" onClick={update.download}>Lataa päivitys</button>
        <button class="btn btn-block" onClick={update.dismiss}>Myöhemmin</button>
      </div>
    </Sheet>
  );
}

/** Passin kortti: asennettu versio, tarkistus ja lataus. Ei näy verkkoselaimessa. */
export function UpdateCard({ update }) {
  if (!update.supported) return null;
  const line = statusLine({ installed: update.installed, remote: update.remote, error: update.error });
  const version = update.installed?.version ? `${update.installed.version} (${update.installed.build})` : "tuntematon";
  return (
    <section class="board-card" aria-label="Päivitykset">
      <div class="board-head">
        <h2>Päivitykset</h2>
        <span class="s">Versio {version}</span>
      </div>
      {line && <p class="s" role="status" aria-live="polite">{line}</p>}
      <div class="sheet-actions">
        {update.available && <button class="btn btn-rasti btn-block" onClick={update.download}>Lataa päivitys</button>}
        <button class="btn btn-block" disabled={update.checking} onClick={() => update.check(true)}>
          {update.checking ? "Tarkistetaan…" : "Tarkista päivitykset"}
        </button>
      </div>
    </section>
  );
}
